import { InjectionToken } from "@angular/core";

/**
 * Used to provide a table to some of the sub-components without causing a circular dependency.
 * Used to avoid nested tables throwing columnDefs errors
 */
export const KISS_TABLE = new InjectionToken<any>("KISS_TABLE");
